import React from 'react';
import { string } from 'prop-types';
import StyledLabel from '../styled-label';
import Stars from '../stars';
import { PT_ITEMS } from './proptypes';

const VPCItems = ({ namespace, items }) => (
  <div className={`${namespace}__items`}>
    {items.map(({ name, value, display_text, aria_label }) => (
      <div className={`${namespace}__item`} key={name}>
        <StyledLabel as="span" className={`${namespace}__item-text`} text={display_text} />
        <Stars className={`${namespace}__stars`} value={value} aria_label={aria_label} />
        <StyledLabel as="span" className={`${namespace}__item-attr-condition`} text={aria_label} />
      </div>
    ))}
  </div>
);

VPCItems.propTypes = {
  namespace: string.isRequired,
  items: PT_ITEMS,
};

VPCItems.displayName = 'VPCItems';

export default React.memo(VPCItems);
